module.exports = __webpack_public_path__ + "img/image1Mobile.04285f73.svg";